var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "label", class: _vm.$style.label }, [
        _vm._v(" Distance(" + _vm._s(_vm.unit) + "): "),
      ]),
      _c("rb-input-range", {
        staticClass: "destinationsManagerMapDistanceFilterRangeInput",
        attrs: {
          min: _vm.minValue,
          max: _vm.maxValue,
          step: 0.1,
          value: _vm.distanceValue,
        },
        on: {
          changed: _vm.handleChange,
          input: _vm.handleSlide,
          keys: _vm.handleKeys,
        },
      }),
      _c("distance-input", {
        class: _vm.$style.textInput,
        attrs: {
          distance: _vm.distanceValueFormatted,
          unit: _vm.unit,
          "min-value": _vm.minValue,
          "max-value": _vm.maxValue,
        },
        on: { changed: _vm.handleChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }